import { AxiosResponse } from "axios"

export const axiosResponse = (response: AxiosResponse) => {
  const { data } = response
  return Promise.resolve(data)
}
